module.exports = __webpack_public_path__ + "static/media/patron_app_icon_new.60acc3d1.svg";